export var LegacyIWTRelaxMode;
(function (LegacyIWTRelaxMode) {
    LegacyIWTRelaxMode["None"] = "IGNORE_NONE";
    LegacyIWTRelaxMode["SINGLE"] = "IGNORE_SINGLE";
})(LegacyIWTRelaxMode || (LegacyIWTRelaxMode = {}));
export var LegacyIWTFeatures;
(function (LegacyIWTFeatures) {
    LegacyIWTFeatures["ROLLSTUHLGERECHT"] = "ROLLSTUHLGERECHT";
    LegacyIWTFeatures["BARRIEREFREI"] = "BARRIEREFREI";
    LegacyIWTFeatures["EINBAUKUECHE"] = "EINBAUKUECHE";
    LegacyIWTFeatures["GARTEN"] = "GARTEN";
    LegacyIWTFeatures["GARAGE_STELLPLATZ"] = "GARAGE_STELLPLATZ";
    LegacyIWTFeatures["BALKON_TERRASSE"] = "BALKON_TERRASSE";
    LegacyIWTFeatures["TEILWEISE_MOEBLIERT"] = "TEILWEISE_MOEBLIERT";
    LegacyIWTFeatures["VOLL_MOEBLIERT"] = "VOLL_MOEBLIERT";
    LegacyIWTFeatures["BAD_MIT_FENSTER"] = "BAD_MIT_FENSTER";
    LegacyIWTFeatures["BAD_MIT_WANNE"] = "BAD_MIT_WANNE";
    LegacyIWTFeatures["PERSONENAUFZUG"] = "PERSONENAUFZUG";
    LegacyIWTFeatures["TEILWEISE_UNTERKELLERT"] = "TEILWEISE_UNTERKELLERT";
    LegacyIWTFeatures["VOLL_UNTERKELLERT"] = "VOLL_UNTERKELLERT";
    LegacyIWTFeatures["NICHT_UNTERKELLERT"] = "NICHT_UNTERKELLERT";
    LegacyIWTFeatures["KEIN_DACHGESCHOSS"] = "KEIN_DACHGESCHOSS";
    LegacyIWTFeatures["KEIN_ERDGESCHOSS"] = "KEIN_ERDGESCHOSS";
    LegacyIWTFeatures["NEUBAU"] = "NEUBAU";
    LegacyIWTFeatures["NEUWERTIG"] = "NEUWERTIG";
    LegacyIWTFeatures["RENOVIERT"] = "RENOVIERT";
    LegacyIWTFeatures["RENOVIERT_SANIERT"] = "RENOVIERT_SANIERT";
    LegacyIWTFeatures["SANIERT"] = "SANIERT";
    LegacyIWTFeatures["TEILSANIERT"] = "TEILSANIERT";
    LegacyIWTFeatures["ERSTBEZUG"] = "ERSTBEZUG";
    LegacyIWTFeatures["RENOVIERUNGSBEDUERFTIG"] = "RENOVIERUNGSBEDUERFTIG";
    LegacyIWTFeatures["SANIERUNGSBEDUERFTIG"] = "SANIERUNGSBEDUERFTIG";
    LegacyIWTFeatures["GEPFLEGT"] = "GEPFLEGT";
    LegacyIWTFeatures["NUR_NEUBAUPROJEKTE"] = "NUR_NEUBAUPROJEKTE";
    LegacyIWTFeatures["KELLER"] = "KELLER";
    LegacyIWTFeatures["FREI"] = "FREI";
    LegacyIWTFeatures["HAUSTIERE_ERLAUBT"] = "HAUSTIERE_ERLAUBT";
    LegacyIWTFeatures["WOHNBERECHTIGUNGSSCHEIN"] = "WOHNBERECHTIGUNGSSCHEIN";
})(LegacyIWTFeatures || (LegacyIWTFeatures = {}));
